import * as React from 'react';
import { connect } from 'react-redux';
import { State } from 'types';
import { fetchAbout } from 'store/ducks/about/actions';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import { getAbout, isLoading } from 'store/ducks/about/selectors';
import {
  Subscription,
  Promo,
  AboutProjectAdvertising,
  AboutProjectContacts,
  Documents,
  Mission,
  Editorial,
  Authors,
  PageMeta,
} from 'components';
// import { AboutStub } from './About.stub';
import './Mission.css';
import { Link } from 'react-router-dom';

type Props = {
  data: any[];
  fetchAbout: () => void;
  isLoading: boolean;
  match: {
    path: string;
  };
};

export default function MissionPage(props: Props) {
  const { isLoading, data, fetchAbout } = props;

  // React.useEffect(() => {
  //     if (!data.length) {
  //         fetchAbout();
  //     }
  // }, []);

  // if (isLoading || !data.length) {
  //     return <AboutStub />;
  // }

  return (
    <>
      <PageMeta
        title="О проекте"
        description="Telesputnik.ru является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента."
        url={`https://telesputnik.ru${props.match.path}`}
      />
      <main className="page about-project container container--page">
        <div className="about-project__main">
          <div className="about-project__content">
            <h1 className="page-title page-title--project page-project__title">
              О проекте
            </h1>
            <Tabs>
              <TabList className="block-tabs__tabs block-tabs__items">
                <Tab className="block-tabs__item">
                  <Link to={'/magazine/about'}>Миссия</Link>
                </Tab>
                <Tab className="block-tabs__item">
                  <Link to={'/magazine/redaction'}>Редакция</Link>
                </Tab>
                <Tab className="block-tabs__item">
                  {/* <Link to={'/magazine/authors'}>Авторы</Link> */}
                  <Link to="/magazine/redaction/policy">
                    Редакционная политика
                  </Link>
                </Tab>
              </TabList>
              <TabPanel>
                <Mission />
              </TabPanel>
              {/* <TabPanel>
                                <Editorial />
                            </TabPanel>
                            <TabPanel>
                                <Authors />
                            </TabPanel> */}
            </Tabs>
          </div>

          <aside className="about-project__sidebar">
            <AboutProjectContacts />
            <AboutProjectAdvertising />
            <Subscription page="about" mod="sidebar" />
            <Promo
              id="promo1"
              type="about"
              tag=""
              link="#"
              img="/img/promo-materials.jpg"
              html=""
              target={'promo1'}
            />
          </aside>
        </div>
        <div className="about-project__others">
          <Documents />
        </div>
      </main>
    </>
  );
}

// const mapStateToProps = (state: State) => ({
//     data: getAbout(state),
//     isLoading: isLoading(state),
// });
// const mapDispatchToProps = { fetchAbout };

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(About) as React.ComponentType;
